// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-06-08T12:06:58+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  192397
//    Project:        628
//    Environment:    8046 - master
//    MD5:            6bb9332ccd82ada24558dc59632e8800
//    Signature:      eyJpdiI6IlRtNXJqNlZoUjRyVjZseW04R0hMaHc9PSIsInZhbHVlIjoiYXpEbTFuSzZrbFwvQ1FwaVQwemVQZTNkNTlpQUl3REZyTEc3ZnFYdGJuS0VhdGd2OWJZcUNLdXZwQUdBZVpFT3d4eVY4M1FNOWJtampNeEgrZWU2SFpmTTdvQ2hPWGV4WWY1ZU5cL0lGOFl6ZzNDMzNsQ1hsUm1RSGRhQzZnYVZwYVpyQnJKVVdVNHBINnA4YnZnR0M2MHdQV1M4VXhoVzdXZDdQQ01FZmhQM0ExNlM1bVZRNHBZR1J1VUU5bUtxWlVKM2ZSOEVNXC9DR1BEUndpZ2xUZmp2dUNTNnZoOXBhMUNQckl2ZE4zcUhGUjJLT0NzXC8wVXNDWFp0UE9ENENwcUFVVHBRVEFobFFmTmpYNFVNTXhiMWJrVzcwb0toOHpmNmg3czlOZFljZERTUHFvQXJcL1pSSUpoQm96eit5YUNoVmY2MzRxVnlWUVFMaDFCR0MzNkpsMHROeVZEUElcL1lERFBzUlM4TDlScTdPU3hjZEk5dForZ1pGeitLQmlRV211UWg5UXRDcm9MVkRHc0RJdlduZHRtK09OVTBSdkR0VXE1UGpvRU5qcnNpOD0iLCJtYWMiOiJiODUxNWI4NmFkNDg4Mjg1MWUyYjFjNGMyMTc4NDE1MDc1ODFiZTZhODI2Y2MzYjRjMGQ2NWRkMTI5Yzg2MmFiIn0=
// Redirects drag-and-drop uploads to the Uploadlift app by extending the
// usual drop zone (using an overlay element) when dragging starts
export class FrameDragdropzoneElement extends HTMLElement {
    #refs = {};
    connectedCallback() {
        this.#refs = {
            frameProductForm: this.closest('frame-product'),
        };
        if (!this.#refs.frameProductForm){
            throw new Error('Missing frame-product parent');
        }
        this.redirectDragAndDrop();
    }

    redirectDragAndDrop() {
        const dragZoneExtender = document.createElement('div');
        dragZoneExtender.style.position = 'fixed';
        dragZoneExtender.style.inset = '0';
        dragZoneExtender.style.zIndex = '9999';
        dragZoneExtender.style.pointerEvents = 'all';
        dragZoneExtender.style.display = `flex`
        dragZoneExtender.style.justifyContent = `center`
        dragZoneExtender.style.alignItems = `center`
        dragZoneExtender.style.color = 'black';
        dragZoneExtender.style.background = 'radial-gradient(circle, rgba(255,255,255) 20%, rgba(255,255,255,0.3) 100%)';
        dragZoneExtender.textContent = `Drop to upload`

        let waiting = false;
        const waitForDrag = () => {
            if (waiting) {
                return;
            }
            waiting = true;
            dragZoneExtender.remove();

            document.addEventListener('dragover', () => {
                waiting = false;
                const uploadliftDragZone = this.#refs.frameProductForm.querySelector('.frame-upload-lift-target .filepond--root');
                if (!uploadliftDragZone) {
                    throw new Error('no upload lift drag zone');
                }

                // Inject drag zone overlay
                uploadliftDragZone.style.contain = 'unset';
                uploadliftDragZone.append(dragZoneExtender);

                // Fallback to dismiss the overlay on click if it gets stuck
                dragZoneExtender.addEventListener('click', () => dragZoneExtender.remove());

                // Needs timeout to allow uploadlift to pick up the drop event
                window.addEventListener('drop', () => setTimeout(waitForDrag, 0), { once: true, capture: true });

                // Reset when drag is cancelled
                window.addEventListener('dragend', waitForDrag, { once: true, capture: true });
                window.addEventListener('dragleave', (e) => {
                    if (e.target === null || e.target === document.body) {
                        waitForDrag();
                    }
                }, { once: true, capture: true });
            }, { once: true });
        };
        waitForDrag();
    }
};
if (!customElements.get('frame-dragdropzone')) {
    customElements.define('frame-dragdropzone', FrameDragdropzoneElement);
}